import get from "lodash/get";
export default () =>
    // https://developer.mozilla.org/en-US/docs/Web/API/Navigator/doNotTrack
    // Edge, Firefox, Chrome
    (get(navigator, "doNotTrack", "1") === "1"
    // IE, Safari
    && get(window, "doNotTrack", "1") === "1")
    // https://globalprivacycontrol.github.io/gpc-spec/
    || navigator.globalPrivacyControl;